export const consumerLogsConstants = {
  GET_ALL_REQUEST: "CONSUMER_LOGS_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "CONSUMER_LOGS_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "CONSUMER_LOGS_GET_ALL_FAILURE",

  GET_TYPE_REQUEST: "CONSUMER_LOGS_GET_TYPE_REQUEST",
  GET_TYPE_SUCCESS: "CONSUMER_LOGS_GET_TYPE_SUCCESS",
  GET_TYPE_FAILURE: "CONSUMER_LOGS_GET_TYPE_FAILURE",
};
